import React, { useEffect, useState } from 'react';
import { Skeleton, useStateInRef } from 'seagull';
import { useIoContext } from "../../../contexts";
import { modifyLoomPlayerStyles } from "./LoomPlayer.utils";
import { VideoPlayerErrors, VideoPlayerStatus } from "../VideoPlayer";
import styles from "./LoomPlayer.module.scss";
const LoomPlayer = props => {
  const {
    url,
    width
  } = props;
  const getProps = useStateInRef(props);
  const {
    loomParser
  } = useIoContext();
  const [html, setHtml] = useState();
  useEffect(() => {
    const {
      onReady,
      onError
    } = getProps();
    (async () => {
      try {
        const {
          title: videoName,
          html
        } = await loomParser(url);
        setHtml(modifyLoomPlayerStyles(html));
        onReady === null || onReady === void 0 || onReady({
          videoName
        });
      } catch (error) {
        onError === null || onError === void 0 || onError({
          message: VideoPlayerErrors[VideoPlayerStatus.NOT_FOUND]
        });
      }
    })();
  }, [url]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.loomContainer
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: "100%",
    width: "100%"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width
    },
    className: styles.loomPlayer,
    dangerouslySetInnerHTML: html ? {
      __html: html
    } : undefined,
    "data-testid": "loom-player"
  }));
};
export default LoomPlayer;